module.exports = __webpack_public_path__ + "static/Thumb_NC1_Conversation_comp-887040117bfbb12344fa75da21b402d5.png";